import { useFetch } from '@reveni-io/reveni-ui'

import { noPaginationParams } from '@/common/constants'
import configurationServices from '@/configuration/services/services'

import { transformResponseGetReturnInstructionSets } from './transformers'

const useReturnInstructionSelector = ({ storeId, instructionType }) => {
  const { data, loading } = useFetch(configurationServices.getReturnInstructionSets, {
    doInitialRequest: !!instructionType,
    params: { storeId, type: instructionType, ...noPaginationParams },
    transformResponse: transformResponseGetReturnInstructionSets,
  })

  return {
    data: data || [],
    loading: !!instructionType && loading,
  }
}

export default useReturnInstructionSelector
